import React from "react";

import Router from "router/router";
import {NavLink, useHistory} from "react-router-dom";

import * as css from "./css/user";
import {observer} from "mobx-react";
import useMyStores from "hooks/useMyStores";

export const User = ({className}) => {
    const history = useHistory();
    const {user} = useMyStores()

    return (
        <css.User className={className}>
            {user.isLogin ? (
                <css.Login.Login
                    onClick={() => {
                        window.open(Router.basename + Router.User.path);
                    }}
                >
                    <css.Login.Label>用户</css.Login.Label>
                    <css.Login.Username>{user.username}</css.Login.Username>
                </css.Login.Login>
            ) : (
                <css.NotLogin.NotLogin>
                    <css.NotLogin.TextWrapper>
                        <css.NotLogin.Text>您好，请先</css.NotLogin.Text>
                        <css.NotLogin.UnderlineColorText
                            as={NavLink}
                            to=""
                            onClick={e => {
                                e.preventDefault();

                                history.replace({
                                    pathname: Router.Login.path
                                });
                            }}
                        >
                            登录
                        </css.NotLogin.UnderlineColorText>
                    </css.NotLogin.TextWrapper>
                    <css.NotLogin.TextWrapper>
                        <css.NotLogin.ColorText
                            as={NavLink}
                            to=""
                            onClick={e => {
                                e.preventDefault();

                                history.replace({
                                    pathname: Router.Register.path
                                });
                            }}
                        >
                            免费注册
                        </css.NotLogin.ColorText>
                    </css.NotLogin.TextWrapper>
                </css.NotLogin.NotLogin>
            )}
        </css.User>
    );

}
export default observer(User);
